module.exports = __webpack_public_path__ + "img/review.7f27835c.svg";